import React, { useEffect, useState } from "react";
import ReactStars from "react-rating-stars-component";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import wish from "../images/wish.svg";
import view from "../images/view.svg";
import cart from "../images/cart.svg";

import { addToWishlist } from "../features/products/productSlilce";
import { addProdToCart, getuserProductWishlist } from "../features/user/userSlice";
import { symbole } from "./commonData";
import ApiResponseModal from "./ApiResponseModal";

const ProductCard = ({ grid, data, fetchCart, fetchWishlist }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [apiModal, setApiModal] = useState({
  show: false,
  type: "success",
  title: "",
  message: "",
});
  /* ---------------- Wishlist ---------------- */
  const wishlistState = useSelector(
    (state) => state?.auth?.wishlist?.wishlist
  );
  const [wishlist, setWishlist] = useState(wishlistState || []);

  useEffect(() => {
    setWishlist(wishlistState || []);
  }, [wishlistState]);

  const isProductInWishlist = (id) =>
    wishlist?.some((item) => item._id === id);

const addToWish = async (id) => {
  try {
    const resultAction = await dispatch(addToWishlist(id));

    // ✅ Success
    if (addToWishlist.fulfilled.match(resultAction)) {
      setApiModal({
        show: true,
        type: "success",
        title: "Wishlist Updated",
        message: "Product added to wishlist successfully",
      });

      dispatch(getuserProductWishlist());
    }

    // ❌ Rejected
    if (addToWishlist.rejected.match(resultAction)) {
      setApiModal({
        show: true,
        type: "error",
        title: "Failed",
        message:
          resultAction.error?.message ||
          "Unable to add product to wishlist",
      });
    }
  } catch (error) {
    setApiModal({
      show: true,
      type: "error",
      title: "Error",
      message: "Something went wrong. Please try again.",
    });
  }
};


  /* ---------------- Cart ---------------- */
const addcart = async (item) => {
  try {
    await dispatch(
      addProdToCart({
        productId: item?._id,
        quantity: 1,
        color: item?.color?.[0] || null,
        price: item?.current_price,
      })
    ).unwrap(); // 🔥 IMPORTANT

    // ✅ Only runs if API truly succeeded
    setApiModal({
      show: true,
      type: "success",
      title: "Added to Cart",
      message: "Product added to cart successfully",
    });

    fetchCart(); // make sure this does NOT throw
  } catch (error) {
    setApiModal({
      show: true,
      type: "error",
      title: "Failed",
      message:
        error?.message ||
        "Unable to add product to cart. Please try again.",
    });
  }
};


  /* ---------------- Modal State ---------------- */
  const [showOptions, setShowOptions] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [quantity, setQuantity] = useState(1);

  const openModal = (item) => {
    setSelectedProduct(item);
    setSelectedSize("");
    setSelectedColor("");
    setQuantity(1);
    setShowOptions(true);
  };

  const proceedCheckout = () => {
    if (
      (selectedProduct?.size?.length > 0 && !selectedSize) ||
      (selectedProduct?.color?.length > 0 && !selectedColor)
    ) {
      return;
    }

    navigate("/checkout", {
      state: {
        product: {
          ...selectedProduct,
          size: selectedSize || null,
          color: selectedColor || null,
          quantity,
        },
      },
    });

    setShowOptions(false);
  };

  return (
    <>
        <ApiResponseModal
  show={apiModal.show}
  type={apiModal.type}
  title={apiModal.title}
  message={apiModal.message}
  onClose={() =>
    setApiModal((prev) => ({ ...prev, show: false }))
  }
/>
      {/* PRODUCTS */}
      {data?.map((item, index) => (
        <div
          key={index}
          className={`${
            location.pathname === "/product"
              ? `gr-${grid}`
              : "col-6 mt-2"
          }`}
        >
          <div className="product-card position-relative h-100 mb-0">
            {/* Wishlist */}
            {/* <div className="wishlist-icon position-absolute">
              <button className="border-0 bg-transparent">
                <img
                  src={wish}
                  alt="wishlist"
                  onClick={() => addToWish(item?._id)}
                />
              </button>
            </div> */}

            {/* Images */}
            <div className="product-image">
              {item?.images?.slice(0, 2).map((img, i) => (
                <img
                  key={i}
                  src={img?.url}
                  className="img-fluid"
                  alt="product"
                  style={{
                    height: "100%",
                    objectFit: "cover",
                    width: "100%",
                  }}
                  onClick={() =>
                    navigate("/product/" + item?._id)
                  }
                                     onError={(e) => {
    e.target.onerror = null;
    e.target.src =item.images[i+1].url;
  }}
                />
              ))}
            </div>

            {/* Details */}
            <div className="product-details">
              <h6 className="brand">{item?.brand}</h6>
              <h5 className="md-product-title">
                {item?.title?.substring(0, 35)}...
              </h5>
              <ReactStars
                count={5}
                size={22}
                value={item?.totalrating}
                edit={false}
                activeColor="#ffd700"
              />
           
          <p className="d-flex align-items-center gap-2 mb-1 text-nowrap">
            <del className="text-muted small">{symbole}{item?.price}</del>
            <span className="fw-semibold">{symbole}{item?.current_price}</span>
          </p>
            </div>

            {/* Buy Now */}
            <div className="cart-button d-block">
              <button
             className="text-white d-flex justify-content-center align-items-center !pl-2 !pr-2 !p-2"
            style={{ background: "#0053e2", borderRadius: "9px", border: "0 none", fontSize: "12px", minHeight: "auto" ,paddingLeft:"8px",paddingRight:"8px"}}
                onClick={() => {
                  const hasOptions =
                    item?.size?.length > 0 ||
                    item?.color?.length > 0;

                  hasOptions
                    ? openModal(item)
                    : navigate("/checkout", {
                        state: { product: item },
                      });
                }}
              >
                <img
                  src={cart}
                  alt="cart"
                  className="me-1"
                  style={{ width: "16px" }}
                />
                Buy Now
              </button>
            </div>

            {/* Action Bar */}
               <div className="action-bar position-absolute my-0">
          <div className="d-flex flex-column gap-1">
               <button className="border-0 bg-light text-link m-2" style={{
              // width:"10px",
              // height:"10px",
              // padding:"1px",
              borderRadius:"30px",
              minHeight:"30px",
              minWidth:"30px"
            }}>
            <img
              src={wish}
              alt="wishlist"
              className="mx-auto"
              onClick={() => addToWish(item?._id)}
            />
          </button>
            <button className="border-0 bg-light text-link m-2" style={{
             
              borderRadius:"30px",
              minHeight:"30px",
              minWidth:"30px"
            }}>
              <img
               className="mx-auto"
                onClick={() => navigate("/product/" + item?._id)}
                src={view}
                alt="view"
              />
            </button>
            <button className="border-0 bg-light text-link m-2" style={{
         
              borderRadius:"30px",
              minHeight:"30px",
              minWidth:"30px"
            }} onClick={() => addcart(item)}>
              <img src={cart} alt="addcart"  className="mx-auto" style={{
              height:"20px",
                width:"20px"
              }} />
            </button>
          </div>
        </div>
          </div>
        </div>
      ))}

      {/* MODAL */}
      {showOptions && selectedProduct && (
        <div
          className="product-modal-backdrop"
          onClick={() => setShowOptions(false)}
        >
          <div
            className="product-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h5 className="fw-bold text-center mb-3">
              Select Options
            </h5>

            {/* Size */}
            {selectedProduct?.size?.length > 0 && (
              <div className="mb-3">
                <p className="fw-semibold mb-2">Size</p>
                <div className="d-flex gap-2 flex-wrap">
                  {selectedProduct.size.map((size) => (
                    <div
                      key={size}
                      className={`size-option ${
                        selectedSize === size ? "active" : ""
                      }`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Color */}
            {selectedProduct?.color?.length > 0 && (
              <div className="mb-3">
                <p className="fw-semibold mb-2">Color</p>
                <div className="d-flex gap-2">
                  {selectedProduct.color.map((color) => (
                    <div
                      key={color._id}
                      className={`color-option ${
                        selectedColor === color._id
                          ? "active"
                          : ""
                      }`}
                      style={{
                        backgroundColor: color.title,
                      }}
                      onClick={() =>
                        setSelectedColor(color._id)
                      }
                    />
                  ))}
                </div>
              </div>
            )}

            {/* Quantity */}
            <div className="mb-3">
              <p className="fw-semibold mb-2">Quantity</p>
              <div className="d-flex gap-3 align-items-center">
                <button
                  className="qty-btn"
                  onClick={() =>
                    setQuantity((q) => Math.max(1, q - 1))
                  }
                >
                  −
                </button>
                <span>{quantity}</span>
                <button
                  className="qty-btn"
                  onClick={() => setQuantity((q) => q + 1)}
                >
                  +
                </button>
              </div>
            </div>

            {/* Validation */}
            {((selectedProduct?.size?.length > 0 &&
              !selectedSize) ||
              (selectedProduct?.color?.length > 0 &&
                !selectedColor)) && (
              <p className="text-danger small">
                Please select all required options
              </p>
            )}

            {/* Actions */}
            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-secondary w-50"
                onClick={() => setShowOptions(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary w-50"
                onClick={proceedCheckout}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL CSS */}
      <style>{`
        .product-modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.6);
          z-index: 99999;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .product-modal {
          background: #fff;
          width: 92%;
          max-width: 420px;
          padding: 20px;
          border-radius: 16px;
          max-height: 90vh;
          overflow-y: auto;
        }
        .size-option {
          padding: 8px 14px;
          border-radius: 8px;
          border: 1px solid #ccc;
          cursor: pointer;
        }
        .size-option.active {
          background: #0053e2;
          color: #fff;
          border-color: #0053e2;
        }
        .color-option {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px solid #ddd;
          cursor: pointer;
        }
        .color-option.active {
          border-color: #0053e2;
        }
        .color-option.active::after {
          content: "✓";
          color: #0053e2;
          font-size: 14px;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .qty-btn {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          border: 1px solid #ccc;
          background: #fff;
        }
      `}</style>
    </>
  );
};

export default ProductCard;
